import mainHTTPClient from '../clients/mainHTTPClient'
import { MAIN_HTTP_API_ENDPOINTS } from '../constants/api/mainHttp'

/**
 * Fetch all languages (ordered by numeric id ascending on the API).
 * @returns {Promise<AxiosResponse<object[]>>}
 */
const GetAll = () => mainHTTPClient.get(MAIN_HTTP_API_ENDPOINTS.LANGUAGES)

/** @deprecated Use GetAll — list endpoint returns a plain array, not a paginated payload. */
const FindMany = () => GetAll()

const LanguageService = {
  GetAll,
  FindMany
}

export default LanguageService
